module.exports = __webpack_public_path__ + "assets/image-55dd5bca6a95a99a4e802d6b7fc14553.svg";